import React from 'react'
import { StyledDiv } from './Button.style'

const Button = ({ disabled, focussed, children }) => (
  <StyledDiv {...{ focussed, disabled }}>{children}</StyledDiv>
)

export default Button
